import { useLazyDataModel } from '@thd-nucleus/data-sources';
import {
  logServiceCallToNewRelicAndLogDataForAutomation
} from '@thd-olt-component-react/cart-common-data';
import { getTmxId } from '../utils/utils';
import { initPaypal as iniPaypalDataModel } from './data-models/paypalInitDataModel';

let promiseResolver;
let promiseRejecter;
export const usePaypalInit = () => {

  const [initPaypalFn, paypalInitResponse] = useLazyDataModel('initPaypal', {
    dataModel: iniPaypalDataModel,
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      logServiceCallToNewRelicAndLogDataForAutomation(
        data, 'initPaypal', { cartId: data?.initPaypal?.cartId });
      promiseResolver(data);
    },
    onError: (errors) => {
      console.log(errors);
      promiseRejecter(errors);
    },
    ssr: false,
    variables: {
      requestContext: {
        cartId: null, // populate from variables or global
        experience: { component: 'checkout', type: 'INITPAYPAL' }, // populate from variables or global
        expTypeFilter: { type: '' }, // populate from variables or global
        tmxProfileId: getTmxId(),
      },
    }
  });

  const initPaypal = (params) => {
    initPaypalFn(params);
    return new Promise((resolve, reject) => {
      promiseResolver = resolve;
      promiseRejecter = reject;
    });
  };

  return [initPaypal, paypalInitResponse];

};
